import { Slider, SliderProps } from "@mui/material";
import { TooltipWrapper } from "../../wrapper";

export type CoreSliderProps = Omit<
	SliderProps,
	"aria-label" | "aria-labelledby" | "onChange" | "value" | "disabled"
> & {
	thumbShape?: "rectangle" | "circle";
	value: number;
	onChange: (value: number) => void;
	disabledTooltip?: React.ReactNode;
	disabled?: boolean;

	/**For Accessibility */
	ariaLabel?: string;
	ariaLabelledBy?: string;
};

export default function CoreSlider({
	thumbShape = "circle",
	ariaLabel,
	ariaLabelledBy,
	onChange,
	value,
	disabled,
	disabledTooltip,
	...props
}: CoreSliderProps) {
	return (
		<TooltipWrapper condition={Boolean(disabled) && disabledTooltip !== undefined} title={disabledTooltip}>
			<Slider
				aria-label={ariaLabel}
				aria-labelledby={ariaLabelledBy}
				sx={{
					"& .MuiSlider-thumb": {
						height: thumbShape === "rectangle" ? "20px" : "14px",
						width: thumbShape === "rectangle" ? "12px" : "14px",
						borderRadius: thumbShape === "rectangle" ? "2px" : "50%",
					},
					...props.sx,
				}}
				// Slider supports multiple thumbs -> for now CoreSlider handles one thumb -> perhaps in the future?
				onChange={(_e, value) => onChange(typeof value === "number" ? value : value[0])}
				value={value}
				disabled={disabled}
				{...props}
			/>
		</TooltipWrapper>
	);
}
